export const createUseValueRegex = (target: string): RegExp => {
  return new RegExp(`\\[value-${target}="(.*?)"\\]`);
};
